import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyI18NModule } from '@vendasta/galaxy/i18n';

import { GalaxyFrequencyComponent } from './frequency.component';
export { GalaxyFrequencyComponent } from './frequency.component';
import { GalaxyFrequencyPipe } from './frequency.pipe';
export { GalaxyFrequencyPipe } from './frequency.pipe';

export const MODULE_IMPORTS = [CommonModule, GalaxyI18NModule, TranslateModule];

export const MODULE_DECLARATIONS = [GalaxyFrequencyComponent, GalaxyFrequencyPipe];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  exports: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
})
export class GalaxyFrequencyModule {}
